import { Suspense, lazy } from 'react';
import Resources from '../components/Resources/Resources';
import ClientSummaries from '../components/Resources/ClientSummaries';
import Notifications from '../components/Resources/Notifications';
import Help from '../components/Help/Help';
import FAQ from '../components/Help/FAQ';
import CustomLoading from '../components/shared/CustomLoading';
import Forms from '../components/Resources/Forms';
import ManageSubAccounts from '../components/Pages/ManageSubAccounts/ManageSubAccounts';
import CreateSubAccount from '../components/MyAccount/CreateSubAccounts';
import EditSubAccounts from '../components/MyAccount/EditSubAccounts';
import AccountManagement from '../components/MyAccount/AccountManagement';
import MyAccount from '../components/MyAccount/MyAccount';
import StaticContentSkeleton from '../components/StaticContentPage/StaticContentSkeleton';
import SelectLocation from '../components/Pages/SelectLocation/SelectLocation';
import Layout from '../components/shared/Layout';
import { TOP_LEVEL_ROUTES, FITNESS_PAGE_ROUTES } from '../scripts/routes';
import ProgramManual from '../components/Resources/ProgramManual';
import ProgramEducationLibrary from '../components/Resources/ProgramEducationLibrary';
import WelcomePacket from '../components/Pages/WelcomePacket';
import FitnessServicesAgreement from '../components/Resources/FitnessServicesAgreement';
import FitnessInstructorServicesAgreements from '../components/Resources/FitnessInstructorServicesAgreements';

const MemberAgreementsPage = lazy(
	() => import('../components/MemberAgreementsPage/MemberAgreementsPage')
);
const StaticContentPage = lazy(
	() => import('../components/StaticContentPage/StaticContentPage')
);
export const unauthorizedCallback = () => {
	const encodedUrl = encodeURIComponent(window.location.href);
	window.location.href = `/identity/login?redirect=${encodedUrl}`;
};
export const postLoginUnauthorizedCallback = () => {
	window.location.href = `/ASH/default.aspx`;
};
export const useRoutesList = () => [
	{
		path: '',
		element: <Layout />,
		children: [
			{
				path: TOP_LEVEL_ROUTES.resources,
				element: <Resources />,
				children: [
					{
						path: FITNESS_PAGE_ROUTES.forms,
						element: <Forms />,
					},
					{
						path: FITNESS_PAGE_ROUTES.clientSummaries,
						element: <ClientSummaries />,
					},
					{
						path: FITNESS_PAGE_ROUTES.programManual,
						element: <ProgramManual />,
					},
					{
						path: FITNESS_PAGE_ROUTES.notifications,
						element: <Notifications />,
					},
					{
						path: FITNESS_PAGE_ROUTES.programEducationLibrary,
						element: <ProgramEducationLibrary />,
					},
					{
						path: FITNESS_PAGE_ROUTES.fitnessServicesAgreement,
						element: <FitnessServicesAgreement />,
					},
					{
						path: FITNESS_PAGE_ROUTES.fitnessInstructorServicesAgreements,
						element: <FitnessInstructorServicesAgreements />,
					},
				],
			},
			{
				path: TOP_LEVEL_ROUTES.help,
				element: <Help />,
				children: [
					{
						path: FITNESS_PAGE_ROUTES.faq,
						element: <FAQ />,
					},
				],
			},
			{
				path: TOP_LEVEL_ROUTES.welcomePacket,
				element: <WelcomePacket />,
			},
			{
				path: TOP_LEVEL_ROUTES.termsAndConditions,
				element: (
					<Suspense fallback={<StaticContentSkeleton />}>
						<StaticContentPage />
					</Suspense>
				),
			},
			{
				path: TOP_LEVEL_ROUTES.privacyStatement,
				element: (
					<Suspense fallback={<StaticContentSkeleton />}>
						<StaticContentPage type='PrivacyStatement' />
					</Suspense>
				),
			},
			{
				path: TOP_LEVEL_ROUTES.memberAgreements,
				element: (
					<Suspense fallback={<CustomLoading />}>
						<MemberAgreementsPage />
					</Suspense>
				),
			},
			{
				path: TOP_LEVEL_ROUTES.account,
				element: <MyAccount />,
				children: [
					{
						path: FITNESS_PAGE_ROUTES.createSubAccount,
						element: <CreateSubAccount />,
					},
					{
						path: FITNESS_PAGE_ROUTES.editSubAccounts,
						element: <EditSubAccounts />,
					},
					{
						path: FITNESS_PAGE_ROUTES.manageSubAccounts,
						element: <ManageSubAccounts />,
					},
					{
						path: FITNESS_PAGE_ROUTES.accountManagement,
						element: <AccountManagement />,
					},
				],
			},
			{
				path: TOP_LEVEL_ROUTES.confirmLocation,
				element: (
					<Suspense fallback={<StaticContentSkeleton />}>
						<SelectLocation />
					</Suspense>
				),
			},
			{
				path: TOP_LEVEL_ROUTES.switchLocation,
				element: (
					<Suspense fallback={<StaticContentSkeleton />}>
						<SelectLocation />
					</Suspense>
				),
			},
			{
				path: '*',
				element: null,
			},
		],
	},
];
